<script lang="ts" setup>
import {parseUrl} from "~/utils/video/videoIdMatcher";

const {videoUrl} = defineProps<{
  videoUrl: string;
}>();
const urlParsed = videoUrl ? parseUrl(videoUrl) : undefined;
</script>

<template>
  <div class="col-breakout article-margin">
    <DssScriptYouTubePlayer
      v-if="urlParsed?.platform === 'youtube'"
      :video-id="urlParsed.id"></DssScriptYouTubePlayer>
    <DssScriptVimeoPlayer
      v-else-if="urlParsed?.platform === 'vimeo'"
      :id="urlParsed.id"></DssScriptVimeoPlayer>
    <div
      v-else
      class="aspect-video bg-neutral-200 grid place-items-center grayscale">
      <div class="flex flex-col gap-4 text-center">
        <span class="font-bold font-sans"
          >It would seem this video is not be supported</span
        >
        <span>{{ videoUrl ?? typeof videoUrl }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
